import {
  AudioExportError, AudioExportJob, AudioExportStage, AudioExportUpdate, AudioExportResult,
  AUDIO_BITRATES, MAX_AUDIO_OUTPUT_BYTES, Mp3Metadata, parseMp3Metadata,
} from './audioExport';

export { AudioExportError as Mp3CompressionError, estimateMp3Bytes, parseMp3Metadata } from './audioExport';
export type { Mp3Metadata } from './audioExport';
export const MAX_MP3_BYTES = MAX_AUDIO_OUTPUT_BYTES;
export const MP3_BITRATES = AUDIO_BITRATES;
export type Mp3Stage = AudioExportStage;
export type Mp3Update = AudioExportUpdate<Mp3Metadata>;
export type Mp3Result = AudioExportResult;

export const validateMp3File = (file: Pick<File, 'name' | 'size'>): void => {
  if (!/\.mp3$/i.test(file.name)) throw new AudioExportError('invalidFile');
  if (file.size === 0) throw new AudioExportError('emptyFile');
  if (file.size > MAX_MP3_BYTES) throw new AudioExportError('fileTooLarge');
};

export const buildMp3Args = (bitrate: number): string[] => {
  if (!(MP3_BITRATES as readonly number[]).includes(bitrate)) {
    throw new AudioExportError('invalidBitrate');
  }
  return [
    '-hide_banner', '-xerror', '-err_detect', 'explode', '-i', '/input/source.mp3',
    '-map', '0:a:0', '-vn', '-c:a', 'libmp3lame', '-b:a', `${bitrate}k`,
    '-map_metadata', '0', '-id3v2_version', '3', '-fs', String(MAX_MP3_BYTES), '/output.mp3',
  ];
};

export class Mp3CompressionJob extends AudioExportJob<Mp3Metadata> {
  constructor() {
    super({
      validateFile: validateMp3File,
      inputName: () => 'source.mp3',
      parseMetadata: parseMp3Metadata,
      buildArgs: (bitrate) => buildMp3Args(bitrate),
    });
  }
}
